module.exports = __webpack_public_path__ + "static/media/plus.2e61202c.svg";